'use client';

import { ComponentProps } from 'react';

import { cx } from '../cva';
import { useField } from './context';

type FieldLabelProps = Omit<ComponentProps<'label'>, 'htmlFor' | 'id'>;

export function FieldLabel({ children, className, ...props }: FieldLabelProps) {
    const { error, id, required } = useField();

    return (
        <label
            {...props}
            className={cx(
                'mb-2xs font-semibold transition',
                'px-sm border-x-1 border-transparent',
                !!error && 'text-error',
                className
            )}
            htmlFor={id}
        >
            {children}
            {required === true && <span> *</span>}
        </label>
    );
}
